import React, {useRef, useState, useEffect, useContext} from 'react';
import {Handle} from 'reactflow';
import {Chatbot} from '../../states/actions';
import {useSelector, shallowEqual} from 'react-redux';
import {onEdit, isLightColor} from '../../helpers/block-helper';


import {User} from '../../states/actions';
import {PreviewComponent, NodeComponent} from './Components'
import { GlobalStateContext } from '../GlobalState';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';

/* const zoomSelector = (s) => s.transform[2]; */




export const TextBlock = React.memo((node) => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);  

  const {block, start, review, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = {progress};
  const {_id} = useSelector(User.get());
  const optionSelectRef = useRef(null);
  
  const [previewMode, setPreviewMode] = useState(globalState.preview ? undefined : false);
 /*  const zoom = useStore(zoomSelector); */


 useEffect(() => {
  setPreviewMode(globalState.preview);
}, [globalState.preview]);


  if (!block) {
    return null;
  }
  const {data} = block;

  const {backgroundColor: bgColor, textColor: txtColor} = data.meta;
  const backgroundColor = bgColor ?? '#2a3f54';
  const textColor = txtColor ?? (isLightColor(backgroundColor) ? '#000000' : '#ffffff');



  return (
    <>
      {!previewMode &&(
        <>
        {/* <div>TEEEEEEEEEME</div>
        <Handle id="source" className="block-handle text-center" type="target" position="top"></Handle>
        <Handle id="next" className="block-handle text-center" type="source" position="bottom"></Handle> */}
              <NodeComponent bot={bot} block={block} name="Text" icon="text" data={data} node={node} start={start} /* zoom={zoom} *//>
         </>
      )}

      {previewMode && (
        //<div className={`block-body node`} onClick={review ? null : () => onEdit(node)}>
              <PreviewComponent bot={bot} data={data} node={node} start={start}/>
        //</div>
      )}

    
     
    </>
  );
});
